import React, { ReactNode } from 'react';

interface Props {
  info?: string;
  onClose?: () => void;
}

export const Info = (props: Props): ReactNode => {
  return (
    <small className={'mb-2'}>
      <i className="pi pi-info-circle mr-2"></i>{props.info}
    </small>
  );
};
